/**
 * file_name.js
 *
 * @경로 : 
 * @목적 : 
 * @설명 : 
 * @진행 : 
 * @주의 :
 * @이슈 :
 * @일자 : 2018.mm.dd
 * @작성 : SuperMoon
 * @참조 :
 */

import B_Util   from 'canvas/base/dev/util/B_Util'
import B_Define from 'canvas/base/dev/util/B_Define'

const B_Wrapper = (function() {

    const $ = {
        _objCanvas : null, // (X) protected
        __className : null,
        __that : null,
        _timer : null,
        _score : null,
        _countdown : null,
    };

    class B_Wrapper {

        constructor(id, queue, onCanvasWorldInit, ClassCanvas) {
            // /*[T]*/ console.log('create B_Wrapper');

            $.__that = this;
            $.__className = ClassCanvas;

            // [S] Prototype 전달 (속성)
            if (typeof this.src != 'undefined') $.__className.prototype.src = this.src; else $.__className.prototype.src = undefined;
            if (typeof this.bgm != 'undefined') $.__className.prototype.bgm = this.bgm; else $.__className.prototype.bgm = undefined;
            if (typeof this.spd != 'undefined') $.__className.prototype.spd = this.spd; else $.__className.prototype.spd = undefined;
            if (typeof this.mut != 'undefined') $.__className.prototype.mut = this.mut; else $.__className.prototype.mut = undefined;
            // if (typeof this.pad !== 'undefined') $.__className.prototype.pad = this.pad; else $.__className.prototype.pad = undefined
            if (typeof this.btn != 'undefined') $.__className.prototype.btn = this.btn; else $.__className.prototype.btn = undefined;
            if (typeof this.header != 'undefined') $.__className.prototype.header = this.header; else $.__className.prototype.header = undefined;

            // [S] Prototype 전달 (메소드)
            if (this.onCanvasInit) $.__className.prototype.onCanvasInit = this.onCanvasInit;
            if (this.onCanvasToolInit) $.__className.prototype.onCanvasToolInit = this.onCanvasToolInit;

            // [S] 캔버스 객체 생성
            this._protectedCanvas = B_Util.getProtected(this);
            this._objCanvas = new ClassCanvas(this._protectedCanvas, id, queue, onCanvasWorldInit);

            // @DES :: onCanvasEvent
            Object.defineProperty(this._protectedCanvas, 'onCanvasEvent', {
                get : function() { return $.__that._objCanvas.onCanvasEvent; },
                set : function(cs) { $.__that._objCanvas.onCanvasEvent = cs; },
                enumerable   : false,
                configurable : true
            });

            // @DES :: animater
            Object.defineProperty(this._protectedCanvas, 'animater', {
                get : function() { return $.__that._objCanvas.ANIMATE; },
                enumerable   : false,
                configurable : true
            });

            //@DES :: TYPE
            Object.defineProperty(this._protectedCanvas, 'LIST', {
                get : function() { return $.__that._objCanvas.LIST; },
                enumerable   : false,
                configurable : true
            });

            //@DES :: REASON
            Object.defineProperty(this._protectedCanvas, 'REASON', {
                get : function() { return $.__that._objCanvas.REASON; },
                enumerable   : false,
                configurable : true
            });

            //@DES :: POPUP_COLOR
            Object.defineProperty(this._protectedCanvas, 'POPUP_COLOR', {
                get : function() { return B_Define.POPUP_COLOR; },
                enumerable   : false,
                configurable : true
            });

            return this._protectedCanvas;
        }

        // [V]
        get res() { return this._objCanvas._res; }
        get onCanvasWorldInit() { return this._objCanvas.onCanvasWorldInit }
        set onCanvasWorldInit(onCanvasWorldInit) { this._objCanvas.onCanvasWorldInit = onCanvasWorldInit }

        // @DES :: canvasMouseX & canvasMouseY
        get canvasMouseX() { if(typeof this._objCanvas !== 'undefined') return this._objCanvas.canvasMouseX; }
        get canvasMouseY() { if(typeof this._objCanvas !== 'undefined') return this._objCanvas.canvasMouseY; }

        // ------------------------ 삭제 예정 ------------------------

        // @DES :: popup {obj}
        get [B_Define.POPUP_ID]() {
            if(typeof this._popup === 'undefined' && typeof this._objCanvas !== 'undefined') {
                this._popup = B_Util.getProtected(this._objCanvas.TOOL[B_Define.POPUP_ID]);
            }
            return this._popup;
        };

        // @DES :: timer {obj}
        get [B_Define.TIMER_ID]() {
            if(typeof this._timer == 'undefined' && typeof this._objCanvas !== 'undefined') {
                this._timer = B_Util.getProtected(this._objCanvas.TOOL[B_Define.TIMER_ID]);
            }
            return this._timer
        };

        // @DES :: score {obj}
        get [B_Define.SCORE_ID]() {
            if(typeof this._score == 'undefined' && typeof this._objCanvas !== 'undefined') {
                this._score = B_Util.getProtected(this._objCanvas.TOOL[B_Define.SCORE_ID]);
            }
            return this._score
        };

        // @DES :: countdown {obj}
        get [B_Define.COUNTDOWN_ID]() {
            if(typeof this._countdown == 'undefined' && typeof this._objCanvas !== 'undefined') {
                this._countdown = B_Util.getProtected(this._objCanvas.TOOL[B_Define.COUNTDOWN_ID]);
            }
            return this._countdown;
        };

        // ------------------------ 삭제 예정 ------------------------

        // [F] public

        /**
         * [ Function :: destory ]
         *
         * @DES :: 캔버스 제거
         */
        destory() {
            try {
                if (typeof this._objCanvas !== 'undefined') {
                    // [#] 논리 종료
                    this._objCanvas.boolEnd = true;
                    // [#] Canvas 관련 (캔버스 모든 객체 제거)
                    this._objCanvas.STAGE.removeAllChildren();
                    // [#] Dom 관련
                    // [*] mobile browser 에선 childNodes.forEach 함수가 없음
                    const CANVAS_WRAPPER_NODES = this._objCanvas.CANVAS_WRAPPER.childNodes;
                    for(let i=0; i<CANVAS_WRAPPER_NODES.length; i++) {
                        if (CANVAS_WRAPPER_NODES[i].tagName.toLowerCase() != "canvas") {
                            this._objCanvas.CANVAS_WRAPPER.removeChild(CANVAS_WRAPPER_NODES[i]);
                        }
                    }
                    delete this._objCanvas;
                }
            } catch (e) {
                B_Util.print(B_Define.MESSAGE["ERROR"] + e);
            }
        }

        allChildRemoveExceptBG() {
            Object.values(this._objCanvas.STAGE.children[0]).forEach(e => {
                try {
                    if (
                        e !== null
                        &&
                        e !== undefined
                        &&
                        typeof e === "object"
                        &&
                        typeof e._remove === "function"
                        &&
                        e._type !== "bg"
                    ) {
                        e._remove();
                    }
                } catch (err) {
                    console.log(e)
                }
            });
        }

        /**
         * [ Function :: reloadGame ]
         *
         * @DES ::
         * @IP1 ::
         * @O.P ::
         * @S.E ::
         */
        reloadGame(){

        }

        /**
         * [Function :: reloadResource]
         *
         * @DES :: 리로드 리소스
         * @IP1 :: inputRes {obj}
         * @IP2 :: cb {func}
         * @S.E :: 캔버스의 preload 재호출 > postload와 연결되어 있음
         */
        reloadResource(inputRes, cb) {
            this._objCanvas.preloadWorld(inputRes, () => {
                if(cb) cb();
            });
        }

        /**
         * [Function :: reloadQeustion]
         *
         * @DES :: 리로드 퀘스쳔
         * @I.P :: clearStatus {bool}
         * @O.P :: 'postload'를 통해서 'reload' 합니다.
         */
        reloadQuestion(clearStatus) {

            // [#] clearStatus 가 있다면 count를 처리해요 ~
            if(typeof clearStatus == 'boolean') {
                const TRY_COUNT = this._objCanvas.TOOL[B_Define.TRY_COUNT_ID];
                const TRY_COUNT_VIEW = this._objCanvas.TOOL[B_Define.TRY_COUNT_VIEW_ID];
                // [#] try-count & try-count-view
                TRY_COUNT.count(clearStatus);
                if(typeof TRY_COUNT_VIEW != 'undefined') TRY_COUNT_VIEW._setCount(TRY_COUNT.entry);
            }

            // [#] 'reload' 합니다.
            this._objCanvas.WORLD._end = true; // 이전의 월드 종료
            this._objCanvas.postload();        // 새로운 월드 생성
        }

        /**
         * [ Function :: getStartTime ]
         *
         * @DES ::
         * @IP1 ::
         * @O.P ::
         * @S.E ::
         */
        getStartTime() {

        }

        /**
         * [ Function :: getSpeed ]
         *
         * @DES :: 스피드 확인하기
         * @OUT :: speed {num}
         */
        getSpeed() {
            return this._objCanvas.speed;
        }

        /**
         * [ Function :: setSpeed ]
         *
         * @DES :: 스피드 수정하기
         * @IP1 :: s {num}
         */
        setSpeed(s) {
            this._objCanvas.speed = s;
        }

        /**
         * [ Function :: getSound ]
         *
         * @DES :: 소리 상태 확인하기
         * @IP1 ::
         * @O.P ::
         * @S.E ::
         */
        getSound() {
            return this._objCanvas.SOUND.isMute;
        }

        /**
         * [ Function :: setSound ]
         *
         * @DES :: 소리 상태 확인하기
         * @IP1 :: stauts {boolean}
         * @O.P :: null
         * @S.E ::
         */
        setSound(status) {
            // console.log('status : ', status);
            if(typeof status === 'boolean')
                this._objCanvas.SOUND.toggle(status);
        }

        /**
         * [ Function :: toggleSound ]
         *
         * @DES :: 소리 상태 수정하기
         * @IP1 ::
         * @O.P ::
         * @S.E ::
         */
        toggleSound(){
            this._objCanvas.SOUND.toggle()
        }

        /**
         * [ Function :: setBG ]
         *
         * @DESC :: 배경 설정하기
         * @arg1 ::
         */
        setBG(res) {
            // /*[T]*/ console.log('setBG');
            this._protectedCanvas.world[B_Define.BG_ID] = this._objCanvas.WORLD.setBG(res);
        }

        /**
         *  @DESC :: 배경 변경
         *  @INPUT  dom imgae 객체 or image url
         */
        changeBG(img) {
            this._objCanvas.WORLD.changeBG(img);
        }

        /**
         * [ Function :: addObject ]
         *
         * @DES :: 객체 추가하기
         * @IP1 :: inputJson {json}
         * @O.P :: null
         * @S.E :: 객체 타입 리소스 참조
         */
        addObject(inputJson) {
            // [#] 외부노출제거
            const cloneJson = B_Util.clone(inputJson);

            // [E] res 객체참조
            if(typeof cloneJson.type === 'undefined') {
                if(cloneJson.res) cloneJson.type = this._objCanvas._res[cloneJson.res].type;
            }
            this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
        }

        /**
         * [ Function :: addGrid ]
         *
         * @DES :: 그리드 추가하기
         * @IP1 :: inputJson {json}
         * @O.P :: null
         * @S.E :: 그리드 타입 자동 추가
         */
        addGrid(inputJson) {
            // [#] 외부노출제거
            const cloneJson = B_Util.clone(inputJson);

            cloneJson.type = B_Define.GRID_TYPE;
            this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
        }

        /**
         * [ Function :: addSolution ]
         *
         * @DES :: 해결책 추가하기
         * @IP1 :: inputJson {json}
         * @O.P :: null
         * @S.E :: 솔루션 타입 자동 추가
         */
        addSolution(inputJson) {
            // /*[T]*/console.log('addSolution in B_Wrapper');

            // [#] 외부노출제거
            const cloneJson = B_Util.clone(inputJson);

            if (cloneJson.live === true) {
                // 아이템을 획득할 때마다 처리 되는 솔루션
                cloneJson.type = B_Define.ITEM_SOLUTION_TYPE;
            } else {
                cloneJson.type  = B_Define.SOLUTION_TYPE;
            }

            this._protectedCanvas.world[cloneJson.id] = this._objCanvas.WORLD.addObject(cloneJson);
        }

        /**
         * [ Function :: getAllVariable ]
         *
         * @DES :: 모든 변수의 값을 가져오기 위한 함수
         * @IP1 :: null
         * @O.P :: res {Array}
         */
        getAllVariable () {
            const res = {};
            Object.keys(this._objCanvas.WORLD.LIST[B_Define.VARIABLE_REAL_TYPE]).forEach((e) => {
                const variable = this._protectedCanvas.world[e];
                res[e] = B_Util.getProtected(variable);
            });
            return res;
        }

        updateResource (key, res) {
            this._objCanvas._res[key] = res;
        }

        addJoyPad (pad) { this._objCanvas.TOOL.addJoyPad(pad); }

        stop() { this._objCanvas.stop(); }

        start() { this._objCanvas.start(); }
    }

    return B_Wrapper;
}());

export default B_Wrapper;



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/base/dev/frame/B_Wrapper.js